<template>
    <div class="text-white navbar navbar-expand-lg navbar-absolute" >
        <ul role="menubar" class="menuScroll flexScroll">
            <li role="menuitem" tabindex="0" class="dc-menu-item" >
                <router-link to="/" :class="{'activeRoute':$route.path == '/'}" class=" menulink font-weight-bold d-flex align-items-center">
                    <!-- <el-tooltip class="item pull-right" effect="dark" content="Dashboard" placement="top"> -->
                        <a href="javascript:;" class=" menulink font-weight-bold d-flex align-items-center">
                            <img v-if="$route.path == '/'" src="/static/images/home_active.svg" class="w-23 mr-2">
                            <img v-else src="https://cdn.digicollect.com/cdn/scmnew/images/menus/home.svg" class="w-23 mr-2">
                            <span class="font-weight-bold" :class="{'new-blue':$route.path == '/'}">Dashboard</span>
                            <div class="mt-2 v-hidden">
                                <i class="icon icon-chevron-down" style="color: #fff"></i>
                            </div>
                        </a>
                    <!-- </el-tooltip> -->
                </router-link>
            </li>
            <!-- <li role="menuitem" tabindex="0" class="dc-menu-item" >
                <router-link to="/ticketdetails" :class="{'activeRoute':String($route.path).startsWith('/ticketdetails') || String($route.path).startsWith('/tickets/create') || String($route.path).startsWith('/archievetickets') || String($route.path).startsWith('/draft') || String($route.path).startsWith('/notifications_page')}" class=" menulink font-weight-bold d-flex align-items-center">
                    <a href="javascript:;" class=" menulink font-weight-bold d-flex align-items-center">
                        <img v-if="String($route.path).startsWith('/ticketdetails') || String($route.path).startsWith('/archievetickets') || String($route.path).startsWith('/tickets/create') || String($route.path).startsWith('/draft') || String($route.path).startsWith('/notifications_page')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/tickets_blue.svg" class="w-19 mr-1">
                        <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/menu/tickets_white.svg" class="w-19 mr-1">
                        <span class="font-weight-bold" :class="{'new-blue':String($route.path).startsWith('/ticketdetails') || String($route.path).startsWith('/archievetickets') || String($route.path).startsWith('/tickets/create') || String($route.path).startsWith('/draft') || String($route.path).startsWith('/notifications_page')}">Tickets</span>
                        <div class="mt-2 v-hidden">
                            <i class="icon icon-chevron-down" style="color: #fff"></i>
                        </div>
                    </a>
                </router-link>
            </li> -->
            <li role="menuitem" id="menu-dropdown" tabindex="0" class="nav-item dropdown dc-menu-item" style="border-bottom-color: transparent;" >
                <a href="javascript:;" :class="{'activeRoute':String($route.path).startsWith('/ticketdetails') || String($route.path).startsWith('/tickets/create') || String($route.path).startsWith('/archievetickets') || String($route.path).startsWith('/draft') || String($route.path).startsWith('/notifications_page')}" class="nav-link menulink d-flex align-items-center" id="navbarOrderLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img v-if="String($route.path).startsWith('/ticketdetails') || String($route.path).startsWith('/archievetickets') || String($route.path).startsWith('/tickets/create') || String($route.path).startsWith('/draft') || String($route.path).startsWith('/notifications_page')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/tickets_blue.svg" class="w-19 mr-1">
                    <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/menu/tickets_white.svg" class="w-19 mr-1">
                    <span class="font-weight-bold" :class="{'new-blue':String($route.path).startsWith('/ticketdetails') || String($route.path).startsWith('/archievetickets') || String($route.path).startsWith('/tickets/create') || String($route.path).startsWith('/draft') || String($route.path).startsWith('/notifications_page')}">Tickets</span>
                    <div class="mt-2">
                        <i class="icon icon-chevron-down" style="color: #fff" :class="{'new-blue':String($route.path).startsWith('/ticketdetails') || String($route.path).startsWith('/tickets/create') || String($route.path).startsWith('/archievetickets') || String($route.path).startsWith('/draft') || String($route.path).startsWith('/notifications_page')}"></i>
                    </div>
                </a>
                <ul class="dropdown-menu dropdown-width subMenuScroll subFlexScroll"  aria-labelledby="dropdownMenuLink">
                    <li class="pointer">
                        <a class="dropdown-sub-item nav-link" @click="changeActive()">Active Tickets</a>
                    </li>
                    <li class="pointer">
                        <a class="dropdown-sub-item nav-link pointer" @click="changeArchieve()">Archive Tickets</a>
                    </li>
                </ul>
            </li>
            <li role="menuitem" tabindex="0" class="dc-menu-item" >
                <!-- <el-tooltip class="item pull-right" effect="dark" content="Facility Management" placement="top"> -->
                    <router-link to="/facilitymanagement/listview" :class="{'activeRoute':$route.path == '/facilitymanagement/listview' || $route.path.startsWith('/facilitymanagement/securityconcern')}" class=" menulink font-weight-bold d-flex align-items-center">
                        <a href="javascript:;" class=" menulink font-weight-bold d-flex align-items-center">
                            <img v-if="$route.path == '/facilitymanagement/listview' || $route.path.startsWith('/facilitymanagement/securityconcern')" src="https://cdn.digicollect.com/cdn/facility/facility_mgmt_blue.svg" class="w-23 mr-2">
                            <img v-else src="https://cdn.digicollect.com/cdn/facility/facility_mgmt_white.svg" class="w-23 mr-2">
                            <span class="font-weight-bold" :class="{'new-blue':$route.path == '/facilitymanagement/listview' || $route.path == '/facilitymanagement/securityconcern' || $route.path.startsWith('/facilitymanagement/securityconcern')}">Facility Management</span>
                            <div class="mt-2 v-hidden">
                                <i class="icon icon-chevron-down" style="color: #fff"></i>
                            </div>
                        </a>
                    </router-link>
                <!-- </el-tooltip> -->
            </li>
            <!-- <li role="menuitem" tabindex="0" class="dc-menu-item" >
                <router-link to="/settings" :class="{'activeRoute':String($route.path).startsWith('/settings') || String($route.path).startsWith('/dynamictemplate')}" class=" menulink font-weight-bold d-flex align-items-center">
                    <a href="javascript:;" class=" menulink font-weight-bold d-flex align-items-center">
                        <img v-if="String($route.path).startsWith('/settings') || String($route.path).startsWith('/dynamictemplate')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/settingNewBlue.svg" class="w-18 mr-2" style="height: 18px;">
                        <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/menu/settingsNewWhite.svg" class="w-18 mr-2" style="height: 18px;">
                        <span class="font-weight-bold" :class="{'new-blue':String($route.path).startsWith('/settings') || String($route.path).startsWith('/dynamictemplate')}">Settings</span>
                        <div class="mt-2 v-hidden">
                            <i class="icon icon-chevron-down" style="color: #fff"></i>
                        </div>
                    </a>
                </router-link>
            </li> -->
            <li role="menuitem" id="menu-dropdown" tabindex="0" class="nav-item dropdown dc-menu-item" style="border-bottom-color: transparent;" >
                <a href="javascript:;" :class="{'activeRoute':String($route.path).startsWith('/settings')}" class="nav-link menulink d-flex align-items-center" id="navbarOrderLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img v-if="String($route.path).startsWith('/settings') || String($route.path).startsWith('/archievetickets') || String($route.path).startsWith('/tickets/create') || String($route.path).startsWith('/draft') || String($route.path).startsWith('/notifications_page')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/tickets_blue.svg" class="w-19 mr-1">
                    <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/menu/tickets_white.svg" class="w-19 mr-1">
                    <span class="font-weight-bold" :class="{'new-blue':String($route.path).startsWith('/settings') || String($route.path).startsWith('/archievetickets') || String($route.path).startsWith('/tickets/create') || String($route.path).startsWith('/draft') || String($route.path).startsWith('/notifications_page')}">Settings</span>
                    <div class="mt-2">
                        <i class="icon icon-chevron-down" style="color: #fff" :class="{'new-blue':String($route.path).startsWith('/settings')}"></i>
                    </div>
                </a>
                <ul class="dropdown-menu dropdown-width subMenuScroll subFlexScroll"  aria-labelledby="dropdownMenuLink">
                    <li class="pointer">
                        <a class="dropdown-sub-item nav-link" href="/settings?type=general">General</a>
                    </li>
                    <li class="pointer">
                        <a class="dropdown-sub-item nav-link" href="/settings?type=facility_management">Facility Management</a>
                    </li>
                    <li class="pointer">
                        <a class="dropdown-sub-item nav-link" href="/settings?type=templatesnew">Templates</a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>
<script>
    import {EventBus} from "./eventBus/nav-bar-event.js";
    export default {
        name: "menubar",
        data() {
            return {

            };
        },
        methods: {
            handleSelect(key, keyPath) {},
            documentClick(e) {
                let el = this.$refs.dropdownMenu
                let target = e.target
            },
            changeActive(){
                this.$router.push({
                    name: "TicketsList",
                    query: {
                        view_ticket: 'overall'
                    }
                })
                EventBus.$emit('updateActiveView')
            },
            changeArchieve(){
                this.$router.push({
                    name: "ArchieveListView"
                })
                EventBus.$emit('updateArchieveView')
            },
            changeView(value){
                this.$router.push({
                    name: "Settings",
                    params: {
                        id: value
                    }
                }).catch(err => {
                    if (err.name == "NavigationDuplicated") {
                        EventBus.$emit('updateSettingView',value)
                    }
                })
            }
        },
        mounted: function () {
            this.$nextTick(function() {
                window.addEventListener('resize',
                    $(document).ready(function(){
                        setTimeout(() => {
                            $('ul.menuScroll.flexScroll').flexMenu();
                        }, 1000);
                    })
                );
            });

            $('.dropdown-menu a.dropdown-toggle').on('click', function(e) {
                if (!$(this).next().hasClass('show')) {
                $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
                }
                var $subMenu = $(this).next(".dropdown-menu");
                $subMenu.toggleClass('show');


                $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
                $('.dropdown-submenu .show').removeClass("show");
                });
                return false;
            });
            $("a.menu-toggle").click(function() {
                $("#menu-dropdown").dropdown("toggle");
            });

            // new More button
            $(document).ready(function(){
                // Show hide popover
                $(".flexMenu-viewMore").click(function(){
                    $(this).find("ul.flexMenu-popup").slideToggle("fast");
                });
            });
            $(document).on("click", function(event){
                var $trigger = $(".flexMenu-viewMore");
                if($trigger !== event.target && !$trigger.has(event.target).length){
                    $("ul.flexMenu-popup").slideUp("fast");
                }
            });

            $(".dc-menu-item").on("click", function(event){
                var $trigger = $(".flexMenu-viewMore");
                if($trigger !== event.target && !$trigger.has(event.target).length){
                    $("ul.flexMenu-popup").slideUp("fast");
                    $("ul.flexMenu-popup").css({"display": "none"});
                }
                $('.flexMenu-viewMore .active').removeClass("active");
                $('.flexMenu-viewMore .active').addClass("active");
                $("ul.flexMenu-popup").css({"display": "none"});
            });
        },
        created() {
            // document.addEventListener('click', this.documentClick)
        },
        destroyed() {
            // document.removeEventListener('click', this.documentClick)
        },
        computed:{
            loggedInUser() {
                return this.$store.state.store.loggedInUser
            },
        },
    };
</script>
<style scoped>
    .menuScroll{
        background-color: #00448f !important;
    }
    ul{
        list-style-type: none !important;
    }
    .w-19{
        width: 18px;
    }
    .w-23{
        width: 21px;
    }
    .dropdown-menu.dropdown-width li a {
        height: 38px !important;
        color: rgb(48, 48, 49) !important;
        line-height: 38px !important;
        background: transparent;
        font-weight: 500;
        font-family: "Poppins" !important;
    }
    .dropdown-menu.dropdown-width .dropdown-toggle.togglePlace::after {
        position: relative;
        top: 13px;
        float: right;
    }
    .dropdown-menu.dropdown-width li a:hover {
        background-color: #ecf1f9 !important;
        color: #00448b !important;
    }
    .dropdown-menu.dropdown-width li a i{
        visibility: hidden;
    }
    .dropdown-menu.dropdown-width li a:hover i{
        visibility: visible !important;
        color: #00448b !important;
    }
    .dropdown-menu.dropdown-width .closeMenu a:hover{
        color: #00448b !important;
    }
    .dropdown-menu.dropdown-width {
        min-width: 14rem !important;
        margin: 0.25rem 0rem 0 !important;
    }
    .dropdown-submenu .dropdown-menu {
        margin-top: -4px !important;
        margin-left: 5px !important;
        margin-right: 0px;
        top: 0px !important;
        left: 100%;
    }
    @media only screen and (max-width: 846px) {
        .dropdown-submenu .dropdown-menu{
            left: 70% !important;
        }
    }
    .dropdown-submenu {
        position: relative;
    }
    .dropdown-menu{
        border-radius: 8px;
    }
    .dropdown-submenu .dropdown-menu .togglePlace:hover {
        color: #00448b !important;
    }
    /* .dc-menu--horizontal>.dc-menu-item:hover {
        border-bottom: 2px solid #00448b !important;
    } */
    @media only screen and (max-width: 900px) {
        .dc-menu-item .dropdown-item.nav-link {
            padding-left: 42px;
        }

        .dc-menu-item.show .dropdown-menu.show {
            transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
            transition-property: color, background-color, opacity;
        }
    }
    .dc-menu {
        background-color: #0d5be6;
    }
    .dc-menu-item {
        display: flex;
        align-items: center;
    }
    .dropdown-menu .dropdown-item.nav-link span {
        color: #303031 !important;
        font-size: 14px;
    }
    .dc-menu {
        border-radius: 2px;
        list-style: none;
        position: relative;
        margin: 0;
        padding-left: 0;
        background-color: #00448b;
    }
    .dc-menu:after,
    .dc-menu:before {
        display: table;
        content: "";
    }
    .dc-menu-item:first-child {
        margin-left: 0;
    }
    .dc-menu li {
        list-style: none;
    }
    .dropdown-menu.show {
        display: block;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
        transition-property: color, background-color, opacity !important;
    }
    .dc-menu li {
        list-style: none;
    }
    a.dropdown-item.nav-link {
        padding: 0px 24px 0px 10px;
    }
    .dc-menu-item .dropdown-toggle::after {
        margin-top: 4px !important;
        margin-left: 10px !important;
    }
    .nav-link>span {
        padding-left: 5px !important;
        font-size: 14px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        text-align: left;
        color: #fff;
    }
    .dropdown-menu.menu-dropdown.show {
        min-width: 14rem !important;
        padding: 0.5rem 0;
        margin: 0.25rem 0rem 0;
    }
    .w-10{
        width: 19px;
    }
    .m-bottom{
        margin-bottom: 2px;
    }
    .activeRoute{
        background-color: #00448b !important;
        background-image: url('https://cdn.digicollect.com/cdn/scmnew/images/menus/images/menu-activation.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-bottom: solid 1px #cce3fc;
    }
    .scm-submenu{
        width: max-content;
    }
    .scm-submenu .dropdown-toggle::after{
        display: none;
    }
    .scm-menu.dropdown-toggle::after{
        display: none;
    }
    .flexMenu-popup{
        background-color: #005dae !important;
    }
</style>